import React, { useEffect } from 'react';

// --- CSS STYLES FOR THIS COMPONENT ---
// We define the styles here as a string.
const styles = `
  .testimonials1-section {
    background-color: #f8f9fa; /* A light, clean background */
  }

  .testimonials1-card {
    background-color: #ffffff;
    border-radius: 12px;
    padding: 2.5rem;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
    border: 1px solid #dee2e6;
    /* This ensures all cards in a row have the same height */
    display: flex;
    flex-direction: column;
  }

  .testimonials1-text {
    font-size: 1.1rem;
    line-height: 1.8;
    color: #495057;
  }

  .testimonials1-image {
    width: 60px;
    height: 60px;
    object-fit: cover;
  }

  .author-name {
    font-weight: bold;
  }

  /* The star rating color will be controlled by the --primary variable */
  .rating-stars {
    color: var(--primary);
  }
`;

const Testimonials1 = () => {
  // Static data for the testimonials
  const testimonials = [
    // ... your testimonial data is correct ...
    { text: "The Maldives package was absolutely incredible...", author: "Sarah Johnson", role: "Maldives Traveler", image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=500&q=80", rating: 5 },
    { text: "Our family trip to Bali was perfectly organized...", author: "Michael Chen", role: "Family Traveler", image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=500&q=80", rating: 5 },
    { text: "The pilgrimage tour to Varanasi was a spiritually enriching experience...", author: "Priya Sharma", role: "Pilgrimage Traveler", image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=500&q=80", rating: 4 }
  ];

  // Effect to inject the styles into the document head
  useEffect(() => {
    const styleTag = document.createElement('style');
    styleTag.innerHTML = styles;
    document.head.appendChild(styleTag);

    // Cleanup function to remove the styles when the component unmounts
    return () => {
      document.head.removeChild(styleTag);
    };
  }, []); // Run this effect only once when the component mounts

  // Helper to render the star icons
  const renderStars = (rating) => {
    let stars = [];
    for (let i = 0; i < 5; i++) {
      // The `text-primary` class will use the --primary variable from your theme
      stars.push(<span key={i} className={i < rating ? 'text-primary' : 'text-muted'}>★</span>);
    }
    return stars;
  };

  return (
    // Use the new prefixed class name for the section
    <section className="testimonials1-section py-5">
      <div className="container">
        {/* Section Header */}
        <div className="text-center mb-5">
          <h2 className="display-5 fw-bold">What Our Travelers Say</h2>
          <p className="lead text-muted">Real stories from our happy customers</p>
        </div>
        
        {/* Testimonials Grid */}
        <div className="row g-4">
          {testimonials.map((testimonial, index) => (
            // Use standard Bootstrap grid classes
            <div key={index} className="col-lg-4 d-flex align-items-stretch">
              {/* Use the new prefixed class names for the card and its elements */}
              <div className="testimonials1-card w-100">
                <p className="testimonials1-text fst-italic mb-4">"{testimonial.text}"</p>
                <div className="d-flex align-items-center mt-auto">
                  <img src={testimonial.image} className="testimonials1-image rounded-circle me-3" alt={testimonial.author} />
                  <div>
                    <h5 className="author-name mb-0">{testimonial.author}</h5>
                    <small className="text-muted">{testimonial.role}</small>
                    <div className="rating-stars mt-1">
                      {renderStars(testimonial.rating)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials1;